<template>
  <div>
    <div class="section full-width" :class="{'sectionTs': brandName === Brand.Travelsphere}">
      <div class="container-fluid">
        <div class="filter-index"
             :class="loading ? 'pb-20' : ''">
          <div class="row">
            <div class="col-lg-3">
              <Filters
                :brand-name="brandName"
                :store="store"
                :filter-text="filterText"
                :filter-view-text="filterViewText"
                :filter-close-text="filterCloseText"
                :filter-clear-text="filterClearText"
              />
              <Filtr
                class="dropdown-filter-mobile"
                :store="store"
                name="SortOrder"
                :label="sortText"
              />
            </div>

            <div class="col-lg-9">
              <div class="preferences-bar" :class="{'preferences-barTs': brandName === Brand.Travelsphere}">
                <p class="preferences-bar__title">{{itemsCount}} - Results found</p>
                <Filtr
                  class="dropdown-filter-desktop"
                  :store="store"
                  name="SortOrder"
                  :label="sortText"
                />
              </div>

              <div class="filter-index__results">
                <div v-if="showNoResultsContent" class="filter-index__no-results">
                  <slot name="noResultsText"></slot>
                </div>

                <ol class="card-list">
                  <li class="card-list__item" v-for="item in items" :key="item.id">
                    <slot :item="item"></slot>
                  </li>
                </ol>

                <Loading v-if="loading" />

                <div class="cta-holder" v-else>
                  <button
                    class="btn btn--alt"
                    :class="{'btn-load-more': brandName === Brand.Travelsphere}"
                    v-if="itemsRemaining > 0"
                    @click="loadMore"
                  >{{loadMoreButtonText}}</button>

                  <div class="pt-20" 
                        v-if="this.totalPages > 1">
                    <strong>{{ this.Take }}</strong> of <strong>{{this.itemsCount}}</strong> tours
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ResultsList from './ResultsList.vue';
import EventBus from '@/vue/EventBus';
import * as helper from '../../modules/helpers.js';
import {Brand} from '../../brand.js';

export default {
  ...ResultsList,
  name: 'FilterIndex',
  props: {
    ...ResultsList.props,
    store: {
      type: String,
      default: 'filter-index'
    },
    brandName: String,
    filterViewText: String,
    filterCloseText: String,
    filterClearText: String,
    filter: String,
    filterText: String,
    sortText: String,
    sortVisible: Boolean,
    listingTitle: String,
    showChildItemsOnly: Boolean,
    noResultsContainerClass: String
  },

  data() {
    return {
      Brand
    };
  },

  watch: {
    showNoResultsContent(isTrue) {
      const block = document.querySelector(`.${this.noResultsContainerClass}`);
      if (isTrue) {
        block.style.display = 'block';
        $(window).resize();
      } else {
        block.style.display = 'none';
      }
    }
  },

  created() {
    ResultsList.created.call(this);
    
    EventBus.$on('ITEMS_LOADED', () => {
      this.$nextTick().then(() => {
        helper.init();
        accordion.init();
        picturefill();
        picturefillBackground();
      });
    });
  }
};
</script>